import { defineStore, acceptHMRUpdate } from 'pinia'
import { unref } from 'vue'
import useState from './useState'
import useGetters from './useGetters'
import useActions from './useActions'

export const useMaintenanceStore = defineStore('maintenance', () => {
  const state = useState()
  const store = {
    initialState: unref(state),
    ...state,
    ...useGetters(state),
    ...useActions(state)
  }
  return store
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMaintenanceStore, import.meta.hot))
}
